import { ChevronDown } from '@tamagui/lucide-icons';
import { Route } from '@unistocks/features/navigation/route';
import { useRouteActive } from '@unistocks/features/navigation/use-route-active';
import { ListItem, ListItemProps, Square } from 'tamagui';

type RouteListItemProps = Omit<ListItemProps, 'onPress'> & {
  route: Route;
  open?: boolean;
  collapsed?: boolean;
  onPress?: (route: Route) => void;
};

export const RouteListItem: React.FC<RouteListItemProps> = ({
  route,
  collapsed,
  open,
  onPress,
  ...props
}) => {
  const isActive = useRouteActive(route);
  const hasChildren = !!route.children?.length;

  return (
    <ListItem
      cursor="pointer"
      gap={'$3'}
      bg={'transparent'}
      justifyContent="center"
      onPress={onPress ? () => onPress(route) : undefined}
      {...props}
    >
      <ListItem.Icon size={props.size} scaleIcon={props.scaleIcon}>
        <route.Icon
          $sm={{ size: collapsed ? '$2' : '$1' }}
          color={isActive ? '$unistocks' : '$headingFont'}
          strokeWidth={isActive ? 2.5 : undefined}
          {...route.iconProps}
        />
      </ListItem.Icon>

      {collapsed ? null : (
        <ListItem.Title
          size={props.size as any}
          color={isActive ? '$unistocks' : undefined}
          fw={isActive ? '$7' : undefined}
        >
          {route.name}
        </ListItem.Title>
      )}

      <ListItem.Icon scaleIcon={1.5}>
        {collapsed || !hasChildren ? null : (
          <Square transition={'quicker'} rotate={open ? '0deg' : '180deg'} ml={'auto'}>
            <ChevronDown />
          </Square>
        )}
      </ListItem.Icon>
    </ListItem>
  );
};

RouteListItem.displayName = 'RouteListItem';
